// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceHolderFragment } from './invoice-holder.fragment.generated';
export type ElectronicInvoiceFragment = { __typename?: 'InvoiceDTO', amount: number, block: string | null, date: LocalDate | null, id: number, ownerCorporateDataId: number, progressive: number, masterInvoice: boolean, holder: { __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null } | null };

export const ElectronicInvoiceFragment = gql`
    fragment ElectronicInvoice on InvoiceDTO {
  amount
  block
  date
  id
  ownerCorporateDataId
  progressive
  holder {
    ...InvoiceHolder
  }
  masterInvoice
}
    ${InvoiceHolderFragment}`;
/* eslint-enable */